import { useNavigate } from "react-router-dom"

import Style from "./style"

import MainHeader from "widget/MainHeader"
import Pagenation from "widget/Pagenation"

import useGetNoticeList from "entity/notice/useGetNoticeList"

import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"
import TableLoading from "shared/ui/TableLoading"

const NoticeList = () => {
    const navigate = useNavigate()

    const [noticeList, isLoading] = useGetNoticeList()

    const btnList = [
        {
            "label": "생성",
            "clickEvent": () => navigate("/notice/create"),
            "deactive": false
        }
    ]
    const sizeList = ["short", "expand", "long"]
    const tableHeadList = ["IDX", "제목", "생성 날짜"]

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList}>공지사항 목록</MainHeader>

            <TableLoading isLoading={isLoading}>
                <TStyle.TableDiv>
                    <TStyle.TableInner>
                        <TStyle.TableRow $title>
                            {tableHeadList.map((elem, index) =>
                                <TStyle.Data key={index} $title $size={sizeList[index]}>{elem}</TStyle.Data>
                            )}
                        </TStyle.TableRow>
                        {noticeList?.data?.notice_list?.map((elem, index) =>
                            <TStyle.TableRow key={index} $odd={index % 2 === 1} onClick={() => navigate(`/notice/${elem?.idx}/detail`)}>
                                <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                                <TStyle.Data $size={sizeList[1]}>{elem?.title}</TStyle.Data>
                                <TStyle.Data $size={sizeList[2]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                            </TStyle.TableRow>
                        )}
                    </TStyle.TableInner>
                </TStyle.TableDiv>
            </TableLoading>

            <Pagenation maxPage={noticeList?.data?.max_page} />
        </Style.Wrapper>
    )
}

export default NoticeList